module.exports = __webpack_public_path__ + "img/product-banner3.885eb80b.png";